module.exports = __webpack_public_path__ + "img/area-2.e93d1c9a.png";